import axios from "../../config/axiosConfig";
import { getDeliveryChallanTransactionTakaNo } from './delivery-challan-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo, getAllProductionTransactionsWithSpecificColumns } from './production-transaction-actions';
import { CREATE_DELIVERY_CHALLAN, GET_DELIVERY_CHALLANS, DELIVERY_CHALLAN_REQUEST, UPDATE_DELIVERY_CHALLAN, DELETE_DELIVERY_CHALLAN, DELIVERY_CHALLAN_REQUEST_FAILURE,
  GET_DELIVERY_CHALLAN_PAGE, DELIVERY_CHALLAN_REQUEST_SUCCESS, GET_LAST_FIVE_DELIVERY_CHALLANS
} from "../types";

export const getDeliveryChallansWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, getSaleBillStatus) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Broker_Id,Vehicle_No,Quality',
        getSaleBillStatus
      };
      return axios.get("/delivery-challan/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallans = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/delivery-challan/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLANS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllDeliveryChallans = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/delivery-challan/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLANS, payload: response.data?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallansByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/delivery-challan/getAllByRange", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDeliveryChallanById = (id, getSaleBillStatus) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      return axios.get(`/delivery-challan/get/${id}`, { params: { getSaleBillStatus } }).then((response) => {
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getLastFiveDeliveryChallanByBookId = (bookId, deliAccountId) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (bookId && deliAccountId) {
        params = { ...params, bookId, deliAccountId };
      }
      return axios.get("/delivery-challan/get-last-five-challan-by-book-id", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_LAST_FIVE_DELIVERY_CHALLANS, payload: response?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createDeliveryChallan = (deliveryChallan) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const newDeliveryChallan = {
        ...deliveryChallan
      };
      return axios.post("/delivery-challan/add", newDeliveryChallan,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DELIVERY_CHALLAN, payload: response.data });
          dispatch(getDeliveryChallanTransactionTakaNo());
          // dispatch(getProductions());
          // dispatch(getProductionTransaction());
          const attributes = ["Taka_No", "Quality", "Grade_Id", "Challan_T_Id"].join(',');
          dispatch(getAllProductionTransactionsWithSpecificColumns(attributes));
          // dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: DELIVERY_CHALLAN_REQUEST_FAILURE,
            error: "Delivery Challan create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDeliveryChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/delivery-challan/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DELIVERY_CHALLAN,
            payload: { id, data: response.data },
          });
          dispatch(getDeliveryChallanTransactionTakaNo());
          // dispatch(getProductions());
          const attributes = ["Taka_No", "Quality", "Grade_Id", "Challan_T_Id"].join(',');
          dispatch(getAllProductionTransactionsWithSpecificColumns(attributes));
          // dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: DELIVERY_CHALLAN_REQUEST_FAILURE,
            error: "Delivery Challan update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDeliveryChallan = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/delivery-challan/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DELIVERY_CHALLAN, id: id });
          dispatch(getDeliveryChallanTransactionTakaNo());
          // dispatch(getProductions());
          // dispatch(getProductionTransaction());
          const attributes = ["Taka_No", "Quality", "Grade_Id", "Challan_T_Id"].join(',');
          dispatch(getAllProductionTransactionsWithSpecificColumns(attributes));
          // dispatch(getProductionTransactionTakaNo());
        }
        const include = ['id', 'Challan_No', 'Order_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Broker_Id', 'Vehicle_No', 'Quality', 'Rate', 'Batch_Weight'].join(',');
        const searchCols = ['Challan_No', 'Order_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Broker_Id', 'Vehicle_No', 'Quality', 'Rate', 'Batch_Weight', 'totalWeight', 'totalMeter', 'totalTaka'].join(',');    
        const { page, pageSize, searchStr, where,  } = getState()?.inventory?.deliveryChallan || {};
        const { generalSetting  } = getState()?.settings.generalSetting || {};

        dispatch(getDeliveryChallansWithPagination(page, pageSize, include, searchStr, searchCols, where, true, !generalSetting?.Delivery_Challan_Lock_Not_Require));

        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingSalesOrdersInChallan = (industryTypeId, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        customerId: auth?.user?.Customer_Id,
        industryTypeId,
        id
      };

      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/delivery-challan/getRemainingOrders`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemainingOrderDeliveryScheduleInChallan = (industryTypeId, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        industryTypeId,
        id
      };
      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/delivery-challan/getRemainingOrderDeliverySchedule`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllTwistOptionsInProductionandDeliveryChallans = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
      };
      return axios.get(`/delivery-challan/getAllTwistOptionsInProductionandDeliveryChallans`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const printEwayDeliveryChallan = (ewaybillNumber) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: SALES_BILL_REQUEST });
      console.log("Printing E-Way Bill with number:", ewaybillNumber);
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber };
      console.log("Params for printing E-Way Bill:", params);
      return axios.get("/delivery-challan/print-eway-bill", { params }).then((response) => {
        return response.data;
        // if (response.data) {
        //   dispatch({ type: GET_SALES_BILLS, payload: response.data });
        // }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEwayDeliveryChallan = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      // let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      // console.log('params', params);
      // let data = {};
      
      return axios.get(`/delivery-challan/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_DELIVERY_CHALLAN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEwayDeliveryChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.post(`/delivery-challan/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DELIVERY_CHALLAN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const validatePartyInDeliveryChallan = (partyId, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      const response = await axios.get("/delivery-challan/validate-party", { params: { ...params, partyId, bookId } });
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const extendValidityEwayDeliveryChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.post(`/delivery-challan/extend-validity-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_DELIVERY_CHALLAN,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPincodeToPincodeDistanceGetDeliveryChallan = (deliveryChallanId, fromPincode) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        billId: deliveryChallanId,
        fromPincode
      };
      const response = await axios.get("/delivery-challan/get-pincode-to-pincode-distance", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};